import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/features/shared/components/ui/badge';
import { statusInfo } from '../lib/status';

export const OrderStatusBadge: React.FC<{ status: string; paymentStatus?: string }> = ({ status, paymentStatus }) => {
  const { t } = useTranslation('everydayServices');
  const info = statusInfo(status, paymentStatus);
  return (
    <Badge variant={info.badge} dot>
      {t(`badge.${info.key}`, info.title)}
    </Badge>
  );
};

export default OrderStatusBadge;
